// src/services/apiKeyService.ts
import api from './api';
import { ApiKey, CreateApiKeyRequest, ValidateKeyRequest, ValidationResponse } from '../types';

export const apiKeyService = {
  getByConsumer: (consumerId: number) => api.get<ApiKey[]>(`/apikeys/consumer/${consumerId}`),
  generate: (data: CreateApiKeyRequest) => api.post<ApiKey>('/apikeys', data),
  validate: (data: ValidateKeyRequest) => api.post<ValidationResponse>('/validation/validate', data),
};
